let player;

/** The light SVG lottie player, loaded once and shared by every VLottie. */
export function loadLottiePlayer() {
    player ??= import('lottie-web/build/player/esm/lottie_light.min.js')
        .then(module => module.default ?? module)
        .catch((error) => {
            player = undefined;
            throw error;
        });
    return player;
}

/**
 * Fetches the player once the page is idle, so an animation shown later (an
 * accordion of a record window, a spinner) draws without waiting for it.
 */
export function preloadLottiePlayer(browser = globalThis) {
    const idle = browser.requestIdleCallback ?? (callback => browser.setTimeout(callback, 200));
    idle(() => { loadLottiePlayer().catch(() => {}); });
}
